import React from "react"

import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	Typography
} from "@material-ui/core"

import { convertCentsInReals } from "@/utils/currencyFormatter"

import {
	UpsellQuantityInfo,
	UpsellQuantityType
} from "@/protocols/planAddons"
import { UpsellDetails } from "@/protocols/upsell"

import useStyles from "@/components/UpsellDialog/UpsellQuantityDialog/UpsellQuantityDialogSuccessContent/styles"
import useUpsellQuantityDialogStyles from "@/components/UpsellDialog/UpsellQuantityDialog/styles"

type UpsellQuantityDialogSuccessContentProps = {
	upsellDetails: UpsellDetails
	upsellQuantityInfo: UpsellQuantityInfo
	upsellQuantityType: UpsellQuantityType
	onCloseClick: () => void
}

const UpsellQuantityDialogSuccessContent: React.FC<UpsellQuantityDialogSuccessContentProps> = (props) => {
	const {
		upsellQuantityInfo,
		upsellQuantityType,
		onCloseClick
	} = props

	const upsellQuantityDialogclasses = useUpsellQuantityDialogStyles()
	const classes = useStyles()

	const getUpsellContent = () => {
		const upsellTypeToContent: Record<UpsellQuantityType, {
			title: string
			description: string
			content: React.ReactNode
		}> = {
			user: {
				title: "Atendentes adicionados com sucesso!",
				description: "Sua equipe acaba de crescer! Agora você pode atender mais clientes e garantir uma experiência ainda melhor.",
				content: (
					<Grid
						container
						direction="column"
						spacing={1}
					>
						<Grid
							item
						>
							<Typography
								variant="body1"
							>
								<strong>Quantidade de Atendentes Contratados:</strong> {upsellQuantityInfo.quantity}
							</Typography>
						</Grid>

						<Grid
							item
						>
							<Typography
								variant="body1"
							>
								<strong>Valor Total:</strong> {convertCentsInReals(upsellQuantityInfo.priceInCents)}
							</Typography>
						</Grid>
					</Grid>
				)
			},
			voice_call_minutes: {
				title: "Minutos de ligação adicionados com sucesso!",
				description: "Seus créditos de ligação foram aumentados! Agora sua equipe pode continuar atendendo por voz sem interrupções.",
				content: (
					<Grid
						container
						direction="column"
						spacing={1}
					>
						<Grid item>
							<Typography variant="body1">
								<strong>Quantidade de Minutos Contratados:</strong> {upsellQuantityInfo.quantity}
							</Typography>
						</Grid>

						<Grid item>
							<Typography variant="body1">
								<strong>Valor Total:</strong> {convertCentsInReals(upsellQuantityInfo.priceInCents)}
							</Typography>
						</Grid>
					</Grid>
				)
			}
		}

		return upsellTypeToContent[upsellQuantityType]
	}

	const upsellContent = getUpsellContent()

	return (
		<Grid
			container
			direction="column"
			justifyContent="space-between"
			className={upsellQuantityDialogclasses.fullDialog}
		>
			<Grid
				item
			>
				<DialogTitle>
					<Grid
						container
						direction="column"
						spacing={2}
					>
						<Grid
							item
						>
							<Typography variant="h3" className={upsellQuantityDialogclasses.dialogTitle}>
								{upsellContent.title}
							</Typography>
						</Grid>
						<Grid
							item
						>
							<Typography className={upsellQuantityDialogclasses.dialogDescription}>
								{upsellContent.description}
							</Typography>
						</Grid>
					</Grid>
				</DialogTitle>
			</Grid>
			<Grid
				item
			>
				<DialogContent className={upsellQuantityDialogclasses.dialogContent}>
					<Grid
						container
						direction="column"
						spacing={2}
					>
						<Grid
							item
						>
							<Typography variant="h6" className={upsellQuantityDialogclasses.planAddonsInformationText}>
								Resumo:
							</Typography>
						</Grid>

						<Grid
							item
						>
							{upsellContent.content}
						</Grid>
					</Grid>
				</DialogContent>
			</Grid>
			<Grid
				item
			>
				<DialogActions className={classes.dialogActions}>
					<Grid
						container
					>
						<Grid
							item
							xs={12}
						>
							<Grid
								container
								justifyContent="flex-start"
							>
								<Grid
									item
									xs={10}
								>
									<Button
										variant="contained"
										className={upsellQuantityDialogclasses.dialogActionPrimaryButton}
										onClick={onCloseClick}
									>
										ENTENDIDO
									</Button>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</DialogActions>
			</Grid>
		</Grid>
	)
}

export default UpsellQuantityDialogSuccessContent
